
import React from 'react'

const PatientDetails = ({patient_name,patient_address,doctor_name,doctorreg_no}) => {
  return (
   <>
  <h4>Patient Name:{patient_name}</h4>
    <h4>Patient Address: {patient_address}</h4>
    <h4>Doctor Name: {doctor_name}</h4>
    <h4>Doctor Reg. No: {doctorreg_no}</h4>
     </>
  )
}

export default PatientDetails